module.exports = __webpack_public_path__ + "static/apple-0504387a1cfdb0b57fb067f5772c0811.png";